/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-disable stylistic/key-spacing */
export const STOREFRONT_URLS = {
  '':                  {pipeline: 'Home-Show'},
  'product':           {pipeline: 'Product-Show', identifier: 'pid'},
  'category':          {pipeline: 'Search-Show', identifier: 'cgid'},
  'page':              {pipeline: 'Page-Show', identifier: 'cid', params: ['mode', 'debug']},
  'folder':            {pipeline: 'Search-ShowContent', identifier: 'fdid'},
  'account':           {pipeline: 'Account-Show'},
  'account/addresses': {pipeline: 'Address-List'},
  'account/orders':    {pipeline: 'Order-History'},
  'account/wishlist':  {pipeline: 'Wishlist-Show'},
  'cart':              {pipeline: 'Cart-Show'},
  'checkout':          {pipeline: 'Checkout-Begin'},
  'homepage':          {pipeline: 'Home-Show'},
  'login':             {pipeline: 'Login-Show'},
  'registration':      {},
  'reset-password':    {pipeline: 'Account-EditPassword'},
  'search':            {pipeline: 'Search-Show', params: ['q']},
};
